import { readLoginLS as readStoredLogin, saveLoginLS as saveStoredLogin, removeLoginLS } from "@delibrandev/utils";

const duration = 30 * 24 * 60 * 60 * 1000;
export { removeLoginLS };
export function saveLoginLS(credentials, platform) {
  saveStoredLogin({ ...credentials, rememberExpiresAt: Date.now() + duration }, platform);
}
export function readLoginLS(platform) {
  const credentials = readStoredLogin(platform);
  if (!credentials) return null;
  // Legacy entries have no trustworthy start time: require a fresh explicit login.
  if (!Number.isFinite(credentials.rememberExpiresAt) || credentials.rememberExpiresAt <= Date.now()) {
    removeLoginLS(platform);
    return null;
  }
  return credentials;
}
